import React, { Fragment, useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Image, Modal } from "antd";
import { Donate, EmptyData, PageLoading, SplitPane } from "../../components";
// import Auth from "../../lib/middleware/auth";
import { useQuery } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import clap from "../../assets/svg/clap.svg";
import { floatBtn, hideScrollbar } from "../../lib/styles/styleLibrary";
import registry, { fetchDonations } from "../../redux/actions/registry";
import { Wrapper } from "./component";
import CurrencyFormat from "react-currency-format";
import { currency } from "../../lib/helpers/currencySymbol";
import { fetchAllWallets } from "../../redux/actions/wallet";
import Auth from "../../lib/middleware/auth";

const Donations = (props) => {
	// const isMobile = useMediaQuery({ maxWidth: 1217 });
	// const experience = Auth.getExperience();
	// const couple = Auth.getCouple();
	const [loading, setLoading] = useState(false);
	const [inviteVisible, setInviteVisible] = useState(false);
	const [walletDt, setWalletDt] = useState([]);
	const [accountSelected, setAccountSelected] = useState({});
	const experience = Auth.getExperience();

	const { data: donorList, isLoading } = useQuery(
		"Donations",
		fetchDonations,
		{
			refetchOnWindowFocus: false,
		}
	);

	const { data: walletData } = useQuery("WalletData", fetchAllWallets, {
		refetchOnWindowFocus: false,
	});
	useEffect(() => {
		if (isEmpty(walletData)) {
			return;
		}
		setWalletDt(walletData.virtual_accounts);
	}, [walletData]);

	const handleThankDonor = async (id) => {
		const data = {
			donationId: id,
		};
		setLoading(true);

		registry
			.thankADonor(data)
			.then((response) => {
				Toast.fire({
					icon: "success",
					title: response,
				});
			})
			.catch((error) => {
				console.log("error thank a donor", error);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const MainSection = () => {
		return (
			<div tw="container">
				{(isLoading || loading) && <PageLoading />}

				<div tw="w-full flex flex-row items-baseline flex-wrap justify-between mt-8">
					<h3 tw="p-0 m-0 font-bold">All Donors</h3>
					<div tw="font-semibold opacity-50">
						{donorList?.donations?.length || 0} Donors
					</div>
				</div>
				<div
					tw="overflow-y-scroll "
					css={hideScrollbar}
					style={{ height: "calc(100vh - 20rem)" }}>
					<div tw="bg-gray-50 flex flex-col gap-4 w-full mt-4 pb-4 rounded mb-12">
						{isEmpty(donorList?.donations) ? (
							<EmptyData />
						) : (
							donorList?.donations.map((donor, i) => {
								const symbol = donor.currency.symbol
									.split("+")
									.pop();
								return (
									<div
										key={i}
										tw="bg-white w-full p-2 flex flex-row gap-2 flex-wrap items-center justify-between"
										css={{
											boxShadow:
												"0px 8px 30px rgba(80, 85, 136, 0.06)",
										}}>
										<span tw="w-auto sm:w-5/12 font-semibold p-2">
											{donor.is_anon
												? "Anonymous 👤"
												: `${donor?.user?.firstname} ${donor?.user?.lastname}`}
										</span>
										<span
											tw="px-3 py-2 text-center w-1/3  sm:w-2/12 rounded-3xl font-semibold text-xs capitalize"
											css={{
												background: "#F4F4F8",
											}}>
											<CurrencyFormat
												value={donor?.amount?.toFixed(
													2
												)}
												displayType={"text"}
												thousandSeparator={true}
												prefix={currency(symbol)}
											/>
										</span>

										<span>
											<Image
												preview={false}
												src={clap}
												alt=""
												width={36}
												height={36}
												onClick={() =>
													// setInviteVisible(true)
													handleThankDonor(donor.id)
												}
												tw="bg-appLightPink p-2 rounded-full flex items-center justify-center hover:(shadow-md cursor-pointer bg-gray-100)"
											/>
										</span>
									</div>
								);
							})
						)}
					</div>
				</div>

				<Modal
					footer=""
					visible={inviteVisible}
					// width={isMobile ? "100%" : "55%"}
					centered
					onCancel={() => setInviteVisible(false)}
					maskClosable={true}>
					<div tw="p-3">
						<Donate
							walletDt={walletDt}
							setAccountSelected={setAccountSelected}
							accountSelected={accountSelected}
						/>
					</div>
				</Modal>

				<button
					css={[floatBtn]}
					// onClick={() => {
					// 	message.error("Kindly setup wallet for donations!");
					// }}
					onClick={() => setInviteVisible(true)}>
					+
				</button>
			</div>
		);
	};

	return (
		<>
			<Wrapper>
				<SplitPane
					wrapDirection={"column"}
					mainHeightAdjust={
						experience !== "couple" ? "16rem" : "auto"
					}
					left={
						experience === "couple" ? (
							<MainSection />
						) : (
							<div tw="h-full w-full overflow-y-scroll">
								<Donate
									walletDt={walletDt}
									setAccountSelected={setAccountSelected}
									accountSelected={accountSelected}
								/>
							</div>
						)
					}
					right={<div tw="h-5/6 w-full bg-gray-100 rounded-md"></div>}
				/>
			</Wrapper>
		</>
	);
};

export default Donations;
